(() => {
  if (customElements.get('beacon-paper-placement')) return;
  customElements.define('beacon-paper-placement', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.observer) return;
        const builder = this.closest('beacon-print-product');
        const options = builder?.querySelector('[data-wttb-options]');
        const guide = this.querySelector('beacon-paper-guide');
        const opener = guide && document.getElementById(guide.dataset.openId);
        if (!options || !guide || !opener) return;
        this.guide = guide;
        this.opener = opener;
        const place = () => {
          const paper = options.querySelector('[data-wttb-key="material"], [data-wttb-key="paperType"], [data-wttb-key="coverMaterial"]');
          const field = paper?.closest('fieldset');
          opener.hidden = !field;
          if (field && opener.parentElement !== field) field.prepend(opener);
        };
        this.observer = new MutationObserver(place);
        this.observer.observe(options, {childList: true});
        place();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      if (this.guide && this.opener && !this.guide.contains(this.opener)) this.guide.prepend(this.opener);
    }
  });
})();
